function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-loop-func */
import { bubble } from '@jd/jmtd-tools/es/element';
import { LinkedList, insert, remove, each } from '@jd/jmtd-tools/es/linked-list';
export function CloseOther(_ref) {
  var isElementMatch = _ref.isElementMatch;
  var nodes = LinkedList(); // 关闭其他dropdown

  function closeOther(target) {
    var isNodeClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return true;
    };
    each(nodes)(function (node) {
      var close = node.close,
          _node$check = node.check,
          check = _node$check === void 0 ? function () {
        return true;
      } : _node$check;

      if (!isNodeClose(node)) {
        return;
      }

      if (node !== target && check(target)) {
        close();
      }
    });
  }

  window.addEventListener('click', function (e) {
    var target = e.target;
    var clickedNode;

    var _iterator = _createForOfIteratorHelper(e.composedPath ? e.composedPath() : bubble(target, null)),
        _step;

    try {
      var _loop = function _loop() {
        var el = _step.value;
        each(nodes)(function (node) {
          if (isElementMatch(el, node)) {
            clickedNode = node;
          }
        });

        if (clickedNode) {
          return "break";
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "break") break;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    closeOther(clickedNode);
  }, {
    capture: true
  });
  return {
    closeOther: closeOther,
    addNode: function addNode(node) {
      insert(nodes, node);
      return node;
    },
    removeNode: function removeNode(node) {
      remove(nodes, node);
      return node;
    }
  };
}